import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button, DatePicker, Input, Select } from 'antd-v5';
import { getVendorItemCollections } from '../../../../api/vendors';
import { getMerchantTags } from '../../../../services/clients';
import { getRequest } from '../../../../core/apiRequests';
import useVendorByKey from '../../../../hooks/query/useVendorByKey';

const { Search } = Input;
const { RangePicker } = DatePicker;

const STATUS_OPTIONS = [
  { label: 'All Statuses', value: '' },
  { label: 'Waiting', value: 'WAITING' },
  { label: 'Ordered', value: 'ORDERED' },
  { label: 'Canceled', value: 'CANCELED' },
  { label: 'Fulfilled', value: 'FULFILLED' },
];

const InquiryFilters = ({ filters, setFilters, onReset, auth }) => {
  const hasActiveFilters = !!(
    filters.clientSearch ||
    filters.family ||
    filters.status ||
    filters.associate ||
    filters.tag ||
    filters.dateRange
  );

  const { vendorId: rolexVendorId } = useVendorByKey('rolex');
  const [familyOptions, setFamilyOptions] = useState([]);
  const [associateOptions, setAssociateOptions] = useState([]);
  const [tagOptions, setTagOptions] = useState([]);

  useEffect(() => {
    if (!rolexVendorId) return;
    getVendorItemCollections([rolexVendorId])
      .then(response => {
        const sorted = (response?.data || [])
          .map(item => ({ label: item.name, value: item.name }))
          .sort((a, b) => a.label.localeCompare(b.label));
        setFamilyOptions([{ label: 'All Collections', value: '' }, ...sorted]);
      })
      .catch(() => setFamilyOptions([]));
  }, [rolexVendorId]);

  useEffect(() => {
    if (auth?.merchantId) {
      getRequest({ params: ['associates', auth.merchantId], query: { singleStore: 0 }, loadingStatusOff: true }).then(data => {
        if (Array.isArray(data)) {
          const sorted = data
            .map(a => ({
              label: a.fullName || `${a.first_name || ''} ${a.last_name || ''}`.trim(),
              value: a.id?.toString(),
            }))
            .sort((a, b) => a.label.localeCompare(b.label));
          setAssociateOptions([{ label: 'All Associates', value: '' }, ...sorted]);
        }
      });
    }
  }, [auth?.merchantId]);

  useEffect(() => {
    getMerchantTags({ query: { limit: 500 }, loadingStatusOff: true })
      .then(response => {
        const sorted = (response?.results || [])
          .map(tag => ({ label: tag.name, value: tag.name }))
          .sort((a, b) => a.label.localeCompare(b.label));
        setTagOptions([{ label: 'All Tags', value: '' }, ...sorted]);
      })
      .catch(() => setTagOptions([]));
  }, []);

  return (
    <div className="rolex-inquiries__filters">
      <Search
        placeholder="Find a client"
        style={{ width: 185 }}
        value={filters.clientSearch}
        onChange={e => setFilters(prev => ({ ...prev, clientSearch: e.target.value }))}
        allowClear
        enterButton
      />
      <Select
        className="inquiry-filter-family"
        popupClassName="inquiry-filter-family-popup"
        style={{ width: 150, textTransform: 'capitalize' }}
        value={filters.family || undefined}
        onChange={val => setFilters(prev => ({ ...prev, family: val ?? '' }))}
        options={familyOptions}
        placeholder="All Collections"
        showSearch
        filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
        popupMatchSelectWidth={false}
        allowClear
      />
      <Select
        style={{ width: 150 }}
        value={filters.status || undefined}
        onChange={val => setFilters(prev => ({ ...prev, status: val ?? '' }))}
        options={STATUS_OPTIONS}
        placeholder="All Statuses"
        popupMatchSelectWidth={false}
        allowClear
      />
      <Select
        style={{ width: 150 }}
        value={filters.associate || undefined}
        onChange={val => setFilters(prev => ({ ...prev, associate: val ?? '' }))}
        options={associateOptions}
        placeholder="All Associates"
        showSearch
        filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
        popupMatchSelectWidth={false}
        allowClear
      />
      <Select
        style={{ width: 150 }}
        value={filters.tag || undefined}
        onChange={val => setFilters(prev => ({ ...prev, tag: val ?? '' }))}
        options={tagOptions}
        placeholder="Filter by Tag"
        showSearch
        filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
        popupMatchSelectWidth={false}
        allowClear
      />
      <RangePicker value={filters.dateRange} onChange={dates => setFilters(prev => ({ ...prev, dateRange: dates }))} />
      {hasActiveFilters && (
        <Button type="link" onClick={onReset} style={{ padding: 0 }}>
          Reset filters
        </Button>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(InquiryFilters);
